import RBAC from "@/api/rbac";

export default {
  mounted(el, binding) {
    const { method, path } = binding.value || {};
    if (!RBAC.canApi(method, path)) el.remove();
  },
  updated(el, binding) {
    const { method, path } = binding.value || {};
    el.style.display = RBAC.canApi(method, path) ? "" : "none";
  },
};
